import i18n from "../../utils/i18n";

export const INPUT_PARAM_DEFAULTS = {
	AMB_TEMP: 25,
	LINE_FREQUENCY: 60,
	ISOLATED: false
};

export const INPUT_PARAM_CONSTRAINTS = {
	AMB_TEMP_MIN: -40,
	AMB_TEMP_MAX: 175
};

export const ERROR_MESSAGES = {
	ambientTemperatureRequired: i18n.t('components.wdValidators.error.messages.temperature.required'),
	voutNumber: i18n.t('components.wdValidators.error.messages.voutNumber'),
	ambientTemperatureNumber: i18n.t('components.wdValidators.error.messages.temperature.number'),
	ambientTemperatureInRange:
		i18n.t('components.wdValidators.error.messages.temperature.inRange') +
		' [' +
		INPUT_PARAM_CONSTRAINTS.AMB_TEMP_MIN +
		',' +
		INPUT_PARAM_CONSTRAINTS.AMB_TEMP_MAX +
		']'
};
